import {getPlaceConfig} from "./place";

const config = getPlaceConfig(1);

export default config
